import React from "react";
import { Head } from "../../components";
import { Link } from "react-router-dom";
import "./NotFound.css"

function NotFound() {
  return (
    <>
      <div className="not-found-g">
        <Link to='./' >
            <Head title="HTTP 404 - NotFound" />
        </Link>
      </div>      
    </>
  );
}

export default NotFound;